import { enum_ } from "valibot"

export enum InputBindingDevice {
  Keyboard,
  Mouse,
  Gamepad,
  Touch,
}

export const InputBindingDeviceSchema = enum_(InputBindingDevice)